import React, { Component } from "react";
import { Grid } from "@mui/material";
import CtDtp from "./CustomTool/CtDtp";
import { connect } from "react-redux";
import {
  mapSetActiveMenu_MenuVisibility_ToProps,
  mapStatetoProps,
} from "../mapRedux/mapReduxProps";
import HOCVerifyIsUser from "../HOC/HOCVerifyIsUser";
import HoCtToastContainer from "../HOC/HoCtToastContainer";
import { withRouter } from "../HOC/withRouter";

class Date extends Component {
  componentDidMount() {
    this.getInfo();
  }

  constructor(props) {
    super(props);
    this.state = {
      formData: {
        dtpFromDate: this.props.dtpFromDate,
        dtpToDate: this.props.dtpToDate,
      },
    };
    // // Bind the method in constructor (optional but good practice)
    // this.formatDate = this.formatDate.bind(this);
  }

  // // Add this method definition
  // formatDate = (dateStr) => {
  //   if (!dateStr) return "";
  //   // If date is already in correct format, return as-is
  //   if (dateStr.includes("-")) {
  //     const [day, month, year] = dateStr.split("-");
  //     return `${year}-${month}-${day}`; // Convert DD-MM-YYYY to YYYY-MM-DD
  //   }
  //   return dateStr;
  // };

  handleOnChange = (e) => {
    const { name, value } = e.target;
    this.setState(
      {
        formData: {
          ...this.state.formData,
          [name]: value,
        },
      },
      () => {
        if (this.props.handleDateChange) {
          this.props.handleDateChange(name, value, this.props.id);
        }
      }
    );
  };

  getInfo = () => {
    this.setState(
      {
        formData: {
          dtpFromDate: this.props.dtpFromDate,
          dtpToDate: this.props.dtpToDate,
        },
      },
      () => {
        document.getElementById("dtpFromDate").focus();
      }
    );
  };

  render() {
    const { formData } = this.state;
    // console.log("dtpFromDate", formData.dtpFromDate);
    // console.log("dtpToDate", formData.dtpToDate);

    return (
      <form>
        {" "}
        <Grid container direction="row" spacing={2}>
          <Grid item style={{ display: "inline-flex" }}>
            <CtDtp
              id="dtpFromDate"
              label="From Date*"
              width="150"
              handleOnChange={this.handleOnChange}
              value={this.state.formData.dtpFromDate}
              onKeyDown={this.props.onKeyDown}
              nextCtrlID={"dtpToDate"}
              accountYear={localStorage.getItem("ACY")}
            />
          </Grid>
          <Grid item>
            <CtDtp
              id="dtpToDate"
              label="To Date*"
              width="150"
              handleOnChange={this.handleOnChange}
              value={this.state.formData.dtpToDate}
              onKeyDown={this.props.onKeyDown}
              accountYear={localStorage.getItem("ACY")}
              defaultAction={this.getInfo}
            />
          </Grid>
        </Grid>
      </form>
    );
  }
}

export default connect(
  mapStatetoProps,
  mapSetActiveMenu_MenuVisibility_ToProps
)(HOCVerifyIsUser(HoCtToastContainer(withRouter(Date))));
